
//orderStatusType
const NEXT_ORDER_STATUS = {
  DEPOSIT_WAIT: 'PAY_DONE', // 입금대기
  PAY_DONE: 'PRODUCT_PREPARE', // 결제완료
  PRODUCT_PREPARE: 'DELIVERY_PREPARE', // 상품준비중
  DELIVERY_PREPARE: 'DELIVERY_ING', //배송준비중
  DELIVERY_ING: 'DELIVERY_DONE', // 배송중
};

import { Vue, Component } from 'vue-property-decorator';

@Component
export default class OrderGridBrokenFreeGiftMixin extends Vue {
  protected showFreeGiftBroken = false;
  protected freeGiftData = {
    id: 'freeGift',
    width: 600,
    title: '사은품 상태 안내',
    nonFooter: true
  }
  
  protected onItemClicked({ columnName, rowKey }) {
    const trigger = this.gridTrigger[columnName];
    trigger && trigger.call(this, rowKey);
  }
	
	protected onRowChecked({ rowKey, instance, checkType }) {
		const data = instance.store.data.viewData;
		const changeCheckBoxStatus = this.changeCheckBoxStatusFunction(instance.el, !checkType.includes('un'));
		
		changeCheckBoxStatus(this.getTargetRowKeysForCheckBox(checkType.includes('All'), data, rowKey));
	}
	
	private changeCheckBoxStatusFunction(el, status: boolean) {
		return (rowKeys: number[]) => rowKeys.forEach(key => {
			el.querySelector(`[data-row-key="${key}"] input`).checked = status;
		});
	}
	
	private getTargetRowKeysForCheckBox(isAll: boolean, data, rowKey: number): number[] {
		if (isAll) return data.map(({ rowKey }) => rowKey);
		const { value } = data.find(item => item.rowKey === rowKey).valueMap.orderNo;
		return data.filter(item => item.valueMap.orderNo.value === value).map(({ rowKey }) => rowKey);
	}
	
	private gridTrigger = {
    productName(rowKey: number) {
      const row = this.gridRef.getRowItems(rowKey);

      if (!row) return;
      if (row.freeGiftConditionBrokenType !== 'CLAIM_DONE') return;
      
      this.showFreeGiftBroken = true;
    },
    // NOTE: 각 주문접수 처리 단계 변경하는 버튼 클릭 시 호출되는 메소드
    procEachBtn(rowKey: number) {
      const item = this.gridRef.getRowItems(rowKey);
      const isBrokenFreeGiftCondition = item.freeGiftConditionBrokenType === 'CLAIM_DONE';
      const confirmMessage = isBrokenFreeGiftCondition ? 'ORDER_LIST_GRIDS_FREE_GIFT_CONDITION_IS_BROKEN' : 'ORDER_LIST_GRIDS_CHANGE_STATUS_CONFIRM';
      const items = [];

      // [배송준비중,배송중] 인 경우 나눔배송 하지 않고 일괄 처리를 위해 shippingNo가 동일한 row를 찾음
      if (item.orderStatusType === 'DELIVERY_PREPARE' || item.orderStatusType === 'DELIVERY_ING') {
        this.orderListContent.forEach((content: any) => {
          if (content.shippingNo === item.shippingNo) {
            items.push(this.gridRef.getRowItems(content.rowKey));
          }
        });
      }
      if (items.length === 0) items.push(item);

      if (!confirm(`${this.$t(confirmMessage)}`)) return;

      // NOTE: 실제 변경되는 부분은 각 컴포넌트 내에서 처리
      if (!this.changeOrderStatus) throw new Error('주문상태를 변경하는 changeOrderStatus 메소드를 구현하세요.');

      this.changeOrderStatus(items, NEXT_ORDER_STATUS[item.orderStatusType]);
    }
  }
}
